
const neReducer = (state,action) => {
     if(action.type === "ADD_NEWS_EVENT"){
          let {newsEvent}=action.payload;
          // console.log(newsEvent.title);
          // let newseventData;
          // newseventData ={
          //      id : newsEvent.id,
          //      titile : newsEvent.titile,
          // };
          return{
               ...state,
               news_event:[newsEvent],
          }
     }
     return state;
}

export default neReducer
